import request from '@/blocks/request';

export function getBrandList(params) {
  return request({
    useLoading: true,
    url: `/activities/${process.env.VUE_APP_H5_KEY}/index`,
    params,
  });
}
